import { datadogRum } from "@datadog/browser-rum";

import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import { datadogRumConfig } from "./environment/monitoring";

if (process.env.MODE !== "development") {
  datadogRum.init(datadogRumConfig);
  datadogRum.startSessionReplayRecording();
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
